import { useState, useEffect } from 'react';
import videoApi from '../../../../api/videoApi';

export const useSavedVideos = userData => {
	const [savedVideoIds, setSavedVideoIds] = useState([]);

	useEffect(() => {
		if (userData.token && userData.user?.userId) {
			videoApi
				.getAllSavedVideoIds(userData.user.userId)
				.then(res => {
					setSavedVideoIds(res.data.savedVideos);
				})
				.catch(err => console.error('Failed to fetch saved videos:', err));
		}
	}, [userData.token, userData.user]);

	return { savedVideoIds, setSavedVideoIds };
};
